export default {
  data() {
    return {
      clubID: '',
    }
  },
  methods: {
    onClubChanged(val) {
      this.clubID = val
    },
  }
}
